import React, { useContext, useRef } from "react";
import { toast } from "react-toastify";
import { addUser } from "../../services/userService";
import loaderContext from "../../../../../context/loader/loaderContext";

const UserModal = ({ onClose, SecurityGroupId }) => {
  const usernameInputRef = useRef(null);
  const userRoleRef = useRef(null);
  const { updateLoaderStatus } = useContext(loaderContext);

  const validateUser = async () => {
    if (!usernameInputRef.current.value.trim()) {
      if (usernameInputRef.current) {
        usernameInputRef.current.style.border = "1px solid red";
        toast.error("User Name is required");
      }
      return;
    }

    // Regular expression for validating email addresses
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Check if all emails in the array match the regex

    const invalidEmails = !emailRegex.test(
      usernameInputRef.current.value.trim()
    );
    if (invalidEmails) {
      if (usernameInputRef.current) {
        usernameInputRef.current.style.border = "1px solid red";
        toast.error("Please enter valid User Name");
      }
      return;
    }
    if (
      !userRoleRef.current.value.trim() ||
      userRoleRef.current.value === "-1"
    ) {
      if (userRoleRef.current) {
        userRoleRef.current.style.border = "1px solid red";
        toast.error("Role is required");
      }
      return;
    }

    try {
      if (usernameInputRef.current) {
        usernameInputRef.current.style.border = ""; // Reset border if input is valid
      }
      updateLoaderStatus(true);
      const response = await addUser(
        usernameInputRef.current.value?.trim(),
        SecurityGroupId,
        userRoleRef.current.value
      );
      if (response !== null && response !== undefined) {
        toast.success("User added successfully");
        onClose();
      }
      updateLoaderStatus(false);
    } catch (error) {
      console.error("Error adding User:", error);
      updateLoaderStatus(false);
    }
  };

  return (
    <div className="modal add-user-modal">
      <div className="modal-content">
        <span className="close" onClick={onClose}>
          &times;
        </span>
        <h2 className="comment-header">Add User</h2>
        <input
          type="text"
          maxLength={100}
          placeholder="User Name"
          className="text-style"
          ref={usernameInputRef}
          onInput={() => (usernameInputRef.current.style.border = "")}
        />
        <select
          ref={userRoleRef}
          className="prompt-skill text-style"
          onChange={() => (userRoleRef.current.style.border = "")}
        >
          <option value="-1">Select Role</option>
          <option key="owners" value="owners">
            Owner
          </option>
          <option key="Members" value="members">
            Member
          </option>
        </select>
        <div className="add-user-button">
          <button
            type="submit"
            onClick={() => validateUser()}
            className="genrate-btn"
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserModal;
